import React, { useState, useEffect } from "react";

const Timer = ({ duration, onTimeout }) => {
  const [timer, setTimer] = useState(duration);

  useEffect(() => {
    let interval;
    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    } else {
      onTimeout();
    }

    return () => {
      clearInterval(interval);
    };
  }, [timer, onTimeout]);

  // Spinner styles
  const spinnerStyle = {
    border: "4px solid rgba(0, 0, 0, 0.1)",
    borderLeftColor: "#000",
    borderRadius: "50%",
    width: "25px",
    height: "25px",
    animation: "spin 1s linear infinite",
  };

  return (
    <div>
      <div style={spinnerStyle}></div>
      <style>
        {`
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

export default Timer;
